import React, { useReducer, useEffect } from 'react'
import { Row, Col, Input, InputGroup, InputGroupText, FormGroup, FormFeedback } from 'reactstrap'
import { InsurerSelect } from './StepClinicInformationDropDowns'
import FormControlHint from './widgets/FormControlHint'
import LabelBold from './widgets/LabelBold'

const StepClinicInformationOptionalInsurance = ({title, hint, onChange, initiallyChecked, locationUniqueId, doRegisterInsuranceId, doRegisterInsuranceCompany, insuranceIdErrorMessage}) => {

  const initialState = {
     hasOther: initiallyChecked,
     insuranceCompany: '',
     insuranceId: '',
     locationUniqueId: locationUniqueId
  }

  const actionReducer = (state, action) => {
    switch (action.type) {
      case 'SET': {
        return {
          ...state,
          [action.name]: action.value
        }
      }
      default:
        return state
    }
  }

  const [state, dispatch] = useReducer(actionReducer, initialState)

  // useEffect(() => {
  //   onChange(state)
  // }, [state, onChange])

  return (
    <React.Fragment>
      <Row>
        <Col sm={8}><LabelBold {...{ required: state.hasOther }}>{title}</LabelBold></Col>
        <Col sm={4} className="pe-4">
          <Row>
            <Col sm={12}>
              <div className='d-flex justify-content-around flex-row'>
                <div>No</div>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="hasOther"
                    name="hasOther"
                    onChange={e => { onChange(e); dispatch({ type: 'SET', name: e.target.name, value: e.target.checked })}}
                    //onChange={onChange}
                    checked={!!state.hasOther}
                    style={{transform: 'scale(1.6)'}}/>
                </div>
                <div>Yes</div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      {state.hasOther && hint && (<Row><Col sm={12}><FormControlHint>{hint}</FormControlHint></Col></Row>)}
      {
        state.hasOther && (
          <React.Fragment>
            <Row className='mt-3'>
              <Col sm={12}>
                <FormGroup>
                  <LabelBold required>Insurance Company</LabelBold>
                  <InsurerSelect
                    isClearable
                    //isCreatable={true}
                    locationUniqueId={state.locationUniqueId}
                    //onChange={opt => dispatch({ type: 'SET', name: 'insuranceCompany', value: opt })}
                    //placeholder="Select existing or add new insurance company name"
                    {...doRegisterInsuranceCompany()}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className='mt-3'>
              <Col sm={12}>
                <FormGroup>
                  <LabelBold required>Insurance ID</LabelBold>
                  <Input
                    type='text'
                    //name='insuranceId'
                    //value={state.insuranceId}
                    {...doRegisterInsuranceId()}
                    //onChange={e => dispatch({ type: 'SET', name: e.target.name, value: e.target.value })}
                  />
                  {insuranceIdErrorMessage && (
                    <FormFeedback className='ms-1'>{insuranceIdErrorMessage}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>

          </React.Fragment>
        )
      }
    </React.Fragment>
  )
}

export default StepClinicInformationOptionalInsurance